import React from 'react'

function About() {
  return (
    <React.Fragment>
      <h1>About</h1>
      <p>This is a TodoList app v1.0.0. It is part a of
         React crash course</p>
    </React.Fragment>
  )
}

export default About;